const DemocraticRepublicOfCongoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111287)">
      <path
        d="M37.7795 10.8302C36.8553 9.03965 35.644 7.35902 34.1431 5.85809C32.6421 4.35707 30.9613 3.14574 29.1709 2.22168L15.0811 15.0815L2.22119 29.1713C3.14533 30.9618 4.35666 32.6425 5.8576 34.1435C7.35853 35.6444 9.03924 36.8557 10.8297 37.7799L24.9195 24.92L37.7795 10.8302Z"
        fill="#FFDA44"
      />
      <path
        d="M5.85727 34.1427C6.69625 34.9816 7.59148 35.7299 8.53047 36.3888L36.3886 8.53047C35.7299 7.59148 34.9816 6.69625 34.1427 5.85727C33.3036 5.01828 32.4084 4.27008 31.4695 3.61133L3.61133 31.4695C4.27 32.4083 5.0182 33.3037 5.85727 34.1427Z"
        fill="#D80027"
      />
      <path
        d="M5.85735 5.85718C-0.452569 12.1671 -1.6639 21.6435 2.22095 29.1705L29.1706 2.22085C21.6436 -1.66391 12.1672 -0.452428 5.85735 5.85718Z"
        fill="#338AF3"
      />
      <path
        d="M34.1423 34.1423C40.4521 27.8325 41.6634 18.3561 37.7788 10.8291L10.8291 37.7787C18.3561 41.6635 27.8325 40.4522 34.1423 34.1423Z"
        fill="#338AF3"
      />
      <path
        d="M10.6583 6.08691L11.7375 9.40855H15.23L12.4046 11.4614L13.4838 14.7829L10.6583 12.73L7.83268 14.7829L8.91205 11.4614L6.08643 9.40855H9.57893L10.6583 6.08691Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111287">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default DemocraticRepublicOfCongoSvg;
